// Vue modules
import Vue from 'vue'
import Router from 'vue-router'

// Components
import Main from '@/components/Main'
import Login from '@/components/01_auth/Login'
import Profile from '@/components/01_auth/Profile'
import Overview from '@/components/02_overview/Overview'
import Providers from '@/components/03_provider/Providers'
import Coupons from '@/components/04_coupon/Coupons'
import Customers from '@/components/05_customer/Customers'
import Media from '@/components/06_media/Media'
import Users from '@/components/07_user/Users'
import Help from '@/components/08_help/Help'
import Imprint from '@/components/09_imprint/Imprint'
import Forbidden from '@/components/97_errors/Forbidden'
import Missing from '@/components/97_errors/Missing'
import Texts from '@/components/11_text/Texts'
// import Stats from '@/components/10_stats/Stats'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/overview',
      meta: {
    	  auth: true,
      },
      children: [
    	  {
              path: 'overview',
              name: 'Overview',
              component: Overview,
              meta: {
            	  auth: true,
              },  
    	  },
    	  {
              path: 'providers',
              name: 'Providers',
              component: Providers,
              meta: {
            	  auth: ['user', 'superadmin'],
              },  
    	  },
    	  {
              path: 'coupons',
              name: 'Coupons',
              component: Coupons,
              meta: {
            	  auth: ['user', 'superadmin'],
              },  
    	  },
    	  {
              path: 'media',
              name: 'Media',
              component: Media,
              meta: {
            	  auth: ['user', 'superadmin'],
              },  
    	  },
    	  {
              path: 'customers',
              name: 'Customers',
              component: Customers,
              meta: {
            	  auth: ['user', 'support', 'superadmin'],
              },  
    	  },
        {
              path: 'texts',
              name: 'Texts',
              component: Texts,
              meta: {
                auth: ['user', 'superadmin'],
              },
        },
    	  {
              path: 'profile',
              name: 'Profile',
              component: Profile,
              meta: {
            	  auth: true,
              },  
    	  },
    	  {
              path: 'users',
              name: 'Users',
              component: Users,
              meta: {
            	  auth: ['admin', 'superadmin'],
              },  
    	  },
    	  {
              path: 'help',
              name: 'Help',
              component: Help,
              meta: {
            	  auth: true,
              },  
    	  },
    	  {
              path: 'imprint',
              name: 'Imprint',
              component: Imprint,
              meta: {
            	  auth: true,
              },  
    	  },
        /*
    	  {
              path: 'stats',
              name: 'Stats',
              component: Stats,
              meta: {
            	  auth: ['user', 'superadmin'],
              },  
    	  },
    	  */
    	  {
              path: '403',
              name: 'Forbidden',
              component: Forbidden,
    	  },
    	  {
              path: '404',
              name: 'Missing',
              component: Missing,
    	  },
      ],
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
      	  auth: false,
        }
    },
    /*
    {
      path: '/*',
      name: 'Missing',
      component: Missing,
      meta: {
        auth: false,
      }
    },
    */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js